import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { MessagesModule }       from '../../app-lite/messages/messages.module';
import { SharedModule }         from '../../app-lite/shared/shared.module';
import { XeroCountryComponent } from './xero.country.component';
import { XeroSignInComponent }  from './xero.sign-in.component';
import { XeroSignupComponent }  from './xero.signup.component';
import { XeroStates }           from './xero.states';

@NgModule({
  declarations: [
    XeroCountryComponent,
    XeroSignInComponent,
    XeroSignupComponent
  ],
  exports: [
    XeroSignInComponent
  ],
  imports: [
    UIRouterUpgradeModule.forChild({ states: XeroStates }),

    MessagesModule,
    SharedModule
  ]
})
export class XeroModule {}
